import Address, { AddressId } from '../domain/entities/Address';
import { diContainer, serviceNames } from '../diContainer/diContainer';
import TransactionLoadHandler, { ITransactionLoad } from './TransactionLoadHandler';
import ShippingRepository from '../repositories/ShippingRepository';
import BillingRepository from '../repositories/BillingRepository';
import SelectNewShippingAddressUseCase from './SelectNewShippingAddressUseCase';
import SelectBillingAddressUseCase from './SelectBillingAddressUseCase';
import NotificationsCollection from '../domain/entities/Notification/NotificationsCollection';
import { RESTRICTION_ERRORS } from '../constants/Errors';

class DeleteShippingAddressUseCase extends TransactionLoadHandler {
  private id: AddressId;

  private shippingRepository: ShippingRepository;

  private billingRepository: BillingRepository;

  private notificationsCollection: NotificationsCollection;

  constructor(id: AddressId, options?: ITransactionLoad) {
    super({ ...options?.transactionLoadOptions, isControlled: true });
    this.id = id;
    this.transactionRepository = diContainer.get(serviceNames.transactionRepository);
    this.shippingRepository = diContainer.get(serviceNames.shippingRepository);
    this.billingRepository = diContainer.get(serviceNames.billingRepository);
    this.notificationsCollection = diContainer.get(serviceNames.notificationsCollection);
  }

  public async run(): Promise<void> {
    await this.shippingRepository.deleteShippingAddress(this.id);
    this.shippingRepository.formStore.clearStore();
    this.shippingRepository.formStore.id = '';

    if (this.notificationsCollection.hasNotification(RESTRICTION_ERRORS.RESTRICTION_APO_ADDRESS_MILITARY)) {
      this.notificationsCollection.clearNotificationByKey(RESTRICTION_ERRORS.RESTRICTION_APO_ADDRESS_MILITARY);
    }

    if (this.notificationsCollection.hasNotification(RESTRICTION_ERRORS.RESTRICTION_APO_ADDRESS)) {
      this.notificationsCollection.clearNotificationByKey(RESTRICTION_ERRORS.RESTRICTION_APO_ADDRESS);
    }

    await this.handleTransactionUpdate();
    if (!this.shippingRepository.addresses.length) {
      new SelectNewShippingAddressUseCase().execute();

      if (this.billingRepository.addresses.length) {
        // set billing address if user deleted all shipping addresses, but has user addresses (e.g. a different country)
        const transaction = await this.transactionRepository.getTransaction();
        transaction.setBillingAddress(this.billingRepository.addresses[0]);
        await this.billingRepository.selectAddress(this.billingRepository.addresses[0]?.id);
      }
    }

    if (!this.billingRepository.addresses.length) {
      new SelectBillingAddressUseCase(Address.NEW_ADDRESS_ID).execute();
    }
  }
}

export default DeleteShippingAddressUseCase;
